import * as React from "react";
import { Checkbox, AnimateTransitionGroup } from "sb-resp-ui";
import { FreeBetDropdown } from "../FreeBetDropdown";
export class FreeBetSection extends React.PureComponent {
    constructor(props) {
        super(props);
        this.checkboxHandler = () => {
            var _a, _b;
            const id = (!this.props.checked && ((_b = (_a = this.freeBetSectionRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-id]")) === null || _b === void 0 ? void 0 : _b.getAttribute("data-id"))) || undefined;
            this.props.selectFreeBet(id);
        };
        this.freeBetSectionRef = React.createRef();
    }
    render() {
        const { id, checked, selectFreeBet, freeBets, selectedFreeBet, useFreeBetPhrase } = this.props;
        return (React.createElement(AnimateTransitionGroup, { runOnMount: true, enter: { animation: "slideDown", duration: 400, delay: 150, style: { height: "" } }, leave: { animation: "slideUp", duration: 400, delay: 150 } }, freeBets.length > 0 && React.createElement("section", { className: "rj-yourbet__free-bet-section", "data-uat": "select-free-bet-holder", ref: this.freeBetSectionRef },
            React.createElement("div", { className: "rj-yourbet__free-bet-wrapper" },
                React.createElement(Checkbox, Object.assign({}, { id, checked, handler: this.checkboxHandler, dataUat: "free-bet-checkbox" })),
                freeBets.length === 1 ?
                    React.createElement("label", { htmlFor: id, className: "rj-yourbet__free-bet-dropdown-wrapper" },
                        React.createElement("span", { className: "rj-yourbet__free-bet-name", "data-id": selectedFreeBet.id, "data-uat": "bet-slip-free-bet-dropdown-label" }, `${useFreeBetPhrase} ${selectedFreeBet.text}`)) : React.createElement(FreeBetDropdown, Object.assign({}, { selectFreeBet, freeBets, selectedFreeBet, useFreeBetPhrase }))))));
    }
}
//# sourceMappingURL=FreeBetSection.js.map